import { render, staticRenderFns } from "./WarehouseExtra.vue?vue&type=template&id=d6d4b104"
import script from "./WarehouseExtra.vue?vue&type=script&lang=js"
export * from "./WarehouseExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports